<script lang="ts">
    import { onMount } from 'svelte';
    import TileEcosystem from './TileEcosystem.svelte';
    import { storeEcosystems } from "../scripts/ecosystem";
    import type {EcosystemInterface, EcosystemCategory} from '../scripts/ecosystem';
    import { storeLanguage, lang_fr } from "../scripts/store";

    export let props: EcosystemCategory;

    let ecosystemForCategory: EcosystemInterface[] = [];

    onMount(async () => {
        storeEcosystems.subscribe(data => {
            ecosystemForCategory = filterEcosystem(data);
        })
        window.scrollTo(0,0);
	});

    function filterEcosystem(ecosystems: EcosystemInterface[]) {
        let ecosystemFiltered: EcosystemInterface[] = [];
        ecosystems.forEach(ecosystem => {
            ecosystem.categories.forEach(category => {
                if (category.id_ecosystem_category == props.id) {
                    ecosystemFiltered.push(ecosystem);
                }
            })
        });
        ecosystemFiltered = ecosystemFiltered.sort((a, b) => {
            let sortByName: number = 1;
            if (a.name < b.name) {
                sortByName = -1;
            }
            return (a.id_partner_level - b.id_partner_level || sortByName);
        })
        return ecosystemFiltered;
    }

</script>
    
<style lang="scss">

    .ecosystemforcategory {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin: 60px 0 60px 0;
        background-color: $color-light-grey;
        box-shadow: 0px 0px 8px $color_text;
        border-radius: 10px;
        &__title {
            padding: 30px 0 30px 0;
        }
        &__tiles {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
        }
    }

    @include large {
    }

</style>

<div class="ecosystemforcategory">
    <div class="ecosystemforcategory__title font__h2">
        {#if ($storeLanguage == $lang_fr)}
        {props.label_fr}
        {:else}
        {props.label_en}
        {/if}
    </div>
    <div class="ecosystemforcategory__tiles">
        {#each ecosystemForCategory as ecosystem}
        <TileEcosystem props={ecosystem}/>
        {/each}
    </div>
</div>    
